import { useState } from "react";
import Validation from "../../../../utils/validation";
import AmountToWords from "../../../_utils/AmountToWords";
import SingleSelectDropDownComponent from "../../../_utils/CommonDropdown/SingleSelectDropdown";
import Amount from "../../../_utils/TransactionCommonComponents/Amount";
import TEXT from "../../../../utils/globalText";
import "./index.css";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";

const TextAuthMatrixSelectTxnAmount = ({
  showRupeeSymbol,
  setShowRupeeSymbol,
  amount,
  setAmount,
  txnType,
  setTxnType,
  amountInWords,
  setAmountInWords,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const allowedValue = (value) => {
    return Validation.allowedAmount(value);
  };

  const handleAmountChange = (val) => {
    if (!val) {
      setAmount("");
      setAmountInWords("");
      setShowRupeeSymbol(false);
      return;
    }

    if (val[0] === "0") return;

    const numericValue = val.replace(/[^0-9.]/g, "");

    if (!allowedValue(numericValue)) return;

    const amountNumber = parseFloat(numericValue);

    const words = !numericValue.trim() ? "" : AmountToWords(amountNumber);

    const adjustedWords =
      amountNumber > GlobalConfiguration?.lengthCheckZero &&
      amountNumber <= GlobalConfiguration?.lengthCheckOne
        ? words.replace("rupees", "rupee")
        : words;

    setAmount(numericValue);
    setAmountInWords(adjustedWords);
    setShowRupeeSymbol(true);
  };

  return (
    <div className="test-auth-txn-amt">
      <div className="text-auth-txn-div">
        <div className="mb-margin-md flex flex-col gap-gap-xs">
          <div className="text-base font-semibold text-text-primary">
            Transaction Type
          </div>
          <div className="text-xs font-normal text-text-secondary">
            Select the transaction type to fetch your entity’s authorization
            matrix configuration.
          </div>
        </div>
        <SingleSelectDropDownComponent
          type="small"
          options={[
            "Beneficiary transaction",
            "Internal transaction",
            "Private transaction",
          ]}
          selected={
            txnType === "Beneficiary"
              ? "Beneficiary transaction"
              : txnType === "Private"
                ? "Private transaction"
                : txnType === "Internal"
                  ? "Internal transaction"
                  : ""
          }
          setSelected={(val) => {
            setTxnType(
              val === "Private transaction"
                ? "Private"
                : val === "Beneficiary transaction"
                  ? "Beneficiary"
                  : val === "Internal transaction"
                    ? "Internal"
                    : "",
            );
          }}
          showSearch={false}
          isOpen={isDropdownOpen}
          placeholder="Select transaction type"
          onOpen={() => {
            setIsDropdownOpen(true);
          }}
          onClose={() => setIsDropdownOpen(false)}
        />
      </div>
      <Amount
        title="Enter Amount"
        amount={amount}
        amountInWords={amountInWords}
        onAmountChange={handleAmountChange}
      />
    </div>
  );
};

export default TextAuthMatrixSelectTxnAmount;
